<div class="w100" fxLayout="row" fxLayoutAlign="space-between">
  <h2 mat-dialog-title>{{'LOGIN.AUTENTICACION.TITULO' | translate}}</h2>
  <button mat-icon-button color="accent" class="ml-10" (click)="salir()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<p>{{'LOGIN.AUTENTICACION.SUBTITULO' | translate}}</p>
<mat-dialog-content class="mat-typography">
  <mat-horizontal-stepper #stepper [(selectedIndex)]="pasoActual">
    <mat-step>
      <ng-template matStepLabel>{{'LOGIN.AUTENTICACION.PASOS.1.TITULO' | translate}}</ng-template>
      <ng-container *ngIf="!saltarQR">
        <p><em>{{'LOGIN.AUTENTICACION.PASOS.1.INSTRUCCION' | translate}}</em></p>
        <div class="w100" fxLayout="column" fxLayoutAlign="center">
          <mat-card class="mat-elevation-z3">
            <mat-card-content>
              <div fxLayout="column" fxLayoutAlign="start center">
                <img class="ht100" [src]="datos.qr">
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
      <ng-container *ngIf="saltarQR">
        <h3><em>{{'LOGIN.AUTENTICACION.PASOS.1.REGISTRADO' | translate}}</em></h3>
      </ng-container>
      <div class="w100 mt-20" fxLayout="row" fxLayoutAlign="center center">
        <button mat-raised-button matStepperNext>{{'LOGIN.AUTENTICACION.BOTONES.SIGUIENTE' | translate}}</button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{'LOGIN.AUTENTICACION.PASOS.2.TITULO' | translate}}</ng-template>
      <p *ngIf="!asciiLocal"><em>{{'LOGIN.AUTENTICACION.PASOS.2.INSTRUCCION' | translate}}</em></p>
      <ng-container *ngIf="asciiLocal">
        <p><em><b>{{'LOGIN.AUTENTICACION.PASOS.2.INFOPREVIA.INFO_1' | translate}}</b></em></p>
        <p><em>{{'LOGIN.AUTENTICACION.PASOS.2.INFOPREVIA.INFO_2' | translate}}</em></p>
      </ng-container>
      <div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
        <mat-form-field appearance="outline">
          <mat-label>{{'LOGIN.AUTENTICACION.PASOS.2.INPUT' | translate}}</mat-label>
          <input matInput [(ngModel)]="claveQR" required class="inputClave">
        </mat-form-field>
      </div>
      <ng-container *ngIf="asciiLocal">
        <p><em>{{'LOGIN.AUTENTICACION.PASOS.2.INFOPREVIA.INFO_3' | translate}}</em></p>
        <p><em><b>{{'LOGIN.AUTENTICACION.PASOS.2.INFOPREVIA.INFO_4' | translate}}</b></em></p>
      </ng-container>
      <div class="w100 mt-20" fxLayout="row" fxLayoutAlign="center center">
        <button mat-raised-button matStepperPrevious class="mr-20" (click)="asciiLocal = undefined">{{'LOGIN.AUTENTICACION.BOTONES.ANTERIOR' | translate}}</button>
        <button mat-raised-button [disabled]="claveQR == ''" matStepperNext (click)="paso2()">{{'LOGIN.AUTENTICACION.BOTONES.SIGUIENTE' | translate}}</button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{'LOGIN.AUTENTICACION.PASOS.3.TITULO' | translate}}</ng-template>
      <h2 *ngIf="!claveQR || !procesoIniciado">{{'LOGIN.AUTENTICACION.PASOS.3.INSTRUCCION' | translate}}</h2>
      <ng-container *ngIf="claveQR">
        <div *ngIf="validando" fxLayout="column" fxLayoutAlign="start center" class="p-20">
            <p>{{'LOGIN.AUTENTICACION.PASOS.3.VALIDANDO' | translate}}</p>
            <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        </div>
        <ng-container *ngIf="!validando">
          <ng-container *ngIf="!resultado">
            <div class="swal2-icon swal2-error swal2-animate-error-icon" style="display: flex;">
              <span class="swal2-x-mark">
                <span class="swal2-x-mark-line-left"></span>
                <span class="swal2-x-mark-line-right"></span>
              </span>
            </div>
            <h3 class="tac">{{'LOGIN.AUTENTICACION.PASOS.3.MAL' | translate}}</h3>
            <div class="w100 mt-20" fxLayout="row" fxLayoutAlign="center center">
              <button mat-raised-button matStepperPrevious class="mr-20" (click)="claveQR = ''">{{'LOGIN.AUTENTICACION.BOTONES.ANTERIOR' | translate}}</button>
            </div>
          </ng-container>
          <ng-container *ngIf="resultado">
            <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: flex;">
              <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
              <span class="swal2-success-line-tip"></span>
              <span class="swal2-success-line-long"></span>
              <div class="swal2-success-ring"></div>
              <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
              <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
            </div>
            <h3 class="tac">{{'LOGIN.AUTENTICACION.PASOS.3.BIEN' | translate}}</h3>
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>
<!-- <div mat-dialog-actions align="end">
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    Cancelar
    <mat-icon class="ml-20">clear</mat-icon>
  </button>
</div> -->
